/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Data_Type_GuidInputs */

const en_enum_setting_data_type_guid = /** @type {(inputs: Enum_Setting_Data_Type_GuidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Type Guid`)
};

const de_enum_setting_data_type_guid = /** @type {(inputs: Enum_Setting_Data_Type_GuidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Typ Guid`)
};

/**
* | output |
* | --- |
* | "Data Type Guid" |
*
* @param {Enum_Setting_Data_Type_GuidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_data_type_guid = /** @type {((inputs?: Enum_Setting_Data_Type_GuidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Data_Type_GuidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_data_type_guid(inputs)
	return de_enum_setting_data_type_guid(inputs)
});